import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CierreRoutingModule } from './cierre-routing.module';
import { CierreComponent } from './components/cierre.component';
import { ImportsModule } from 'src/app/modules/shared/imports/imports.module';
import { TimeAgoPipe } from 'time-ago-pipe';


@NgModule({
  declarations: [
    CierreComponent
  ],
  imports: [
    CommonModule,
    CierreRoutingModule,
    ImportsModule,
  ],
  providers: [TimeAgoPipe],
})
export class CierreModule { }
